import styled, { css } from 'styled-components'
import { tabletBreakpoint } from 'react-components'

export const FilterContainer = styled.div`
    border-bottom: 1px dotted #d5d5d5;

    &:last-child {
        border-bottom: none;
    }
`

export const FilterContentContainer = styled.div<{
    isMultiple?: boolean
    isPriceFilter?: boolean
}>(
    ({ isMultiple, isPriceFilter, theme }) => css`
        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            display: block !important;
            position: relative;
            top: unset;
            z-index: 1;
            left: unset;
            ${isMultiple || isPriceFilter ? 'min-width: 26.25rem;' : 'min-width: 15.625rem;'}
            background-color: ${theme.colors.white};
            border: 0;
            box-sizing: border-box;
            box-shadow: unset;
            border-radius: ${theme.typography.border.radius.small};
            width: ${theme.layout.fill};
            min-width: unset;
        }
    `,
)

export const StyledFilterContent = styled.div(
    ({ theme }) => css`
        font-size: ${theme.typography.font.size.medium};
        user-select: none;
        width: ${theme.layout.fill};
        padding: 0.25rem 0 0;
    `,
)
